import React from "react";

const AppLanding = () => {
  const PLAY_STORE =
    "https://play.google.com/store/apps/details?id=com.ta.wallet.tawallet&hl=en_IN";

  const APP_STORE =
    "https://apps.apple.com/in/app/ta-wallet/id1381087275";

  return (
    <div
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "linear-gradient(135deg, #e6f4ea, #f0f9ff)",
        fontFamily: "sans-serif"
      }}
    >
      <div
        style={{
          background: "#ffffff",
          padding: "40px",
          borderRadius: "20px",
          boxShadow: "0 15px 40px rgba(0,0,0,0.1)",
          textAlign: "center",
          width: "350px"
        }}
      >
        <h2 style={{ marginBottom: "10px" }}>
          Download Our App
        </h2>

        <p style={{ color: "#555", marginBottom: "25px" }}>
          Choose your platform
        </p>

        <a
          href={PLAY_STORE}
          style={{
            display: "block",
            background: "#34A853",
            color: "#fff",
            padding: "14px",
            borderRadius: "10px",
            textDecoration: "none",
            fontWeight: "bold",
            marginBottom: "15px"
          }}
        >
          Google Play Store
        </a>

        <a
          href={APP_STORE}
          style={{
            display: "block",
            background: "#000",
            color: "#fff",
            padding: "14px",
            borderRadius: "10px",
            textDecoration: "none",
            fontWeight: "bold"
          }}
        >
          App Store
        </a>
      </div>
    </div>
  );
};

export default AppLanding;